<!--begin::Body-->
<div class="kt-login__body auth-right">

    <div class="customer-logo w-100">
      <img [src]="imagePaths.uptimeLogoOriginal" *ngIf="!isLogoAvailable" alt="uptime-logo" width="75em" />
      <img [src]="isLogoAvailable" *ngIf="isLogoAvailable" width="75em" alt="logo" />
    </div>

  <!--begin::Signin-->
  <div class="kt-login__form form-body">
    <div class="kt-login__title margin-0 w-470">
      <h5 class="sign-in-text">{{ 'AUTH.RESET.TITLE' | translate }}</h5>
    </div>

    <kt-auth-notice></kt-auth-notice>

    <form class="kt-form margin-0 w-470" [formGroup]="resetForm" autocomplete="off">
      <div class="form-group form-entity d-flex flex-column pad-b-14">
        <kt-input
          [label]="'AUTH.GENERAL.ENTER_OTP' | translate"
          [placeholder]="'AUTH.GENERAL.ENTER_OTP' | translate"
          formControlName="otp"
          [maxLength]="6"
          (inputBlur)="updateErrors()"
          [errorMessage]="otpErrorMessage">
        </kt-input>

        <div class="d-flex align-items-center text-color">
          <span>{{ 'AUTH.RESET.VERIFICATION_CODE_SENT' | translate }} <strong>{{ email }}</strong></span>
          <kt-button variant="text" [startIcon]="{name: 'edit'}" [noFullWidth]="true" [noPadding]="true" (onClick)="goToForgotPassword()"></kt-button>
        </div>

        <div class="text-color">
          <span class="fw-normal">
            {{ 'AUTH.RESET.NO_CODE_RECEIVED' | translate }}
            <span class="text-muted" *ngIf="resendCountdown > 0"><span class="resend-label">{{ 'AUTH.RESET.RESEND' | translate }}</span><span class="resend-timer"> {{ 'AUTH.RESET.RESEND_IN' | translate }} {{ resendCountdown }}s</span></span>
            <a href="javascript:;" class="resend-link" *ngIf="resendCountdown === 0" (click)="resendOTP()">{{ 'AUTH.RESET.RESEND' | translate }}</a>
          </span>
        </div>
      </div>
      <div class="form-group form-entity d-flex flex-column pad-b-14 mt-3">
        <kt-input
          type="password"
          [label]="'AUTH.RESET.NEWPASSWORD' | translate"
          [placeholder]="'AUTH.RESET.NEWPASSWORD' | translate"
          formControlName="password"
          (inputBlur)="updateErrors()"
          [errorMessage]="passwordErrorMessage">
        </kt-input>

        <kt-password-requirements *ngIf="resetForm.get('password')?.dirty" [password]="resetForm.get('password')?.value"></kt-password-requirements>
      </div>

      <div class="form-group form-entity d-flex flex-column my-5">
        <kt-input
          type="password"
          [label]="'AUTH.RESET.REENTERNEWPASSWORD' | translate"
          [placeholder]="'AUTH.RESET.REENTERNEWPASSWORD' | translate"
          formControlName="confirmPassword"
          (inputBlur)="updateErrors()"
          [errorMessage]="confirmPasswordErrorMessage">
        </kt-input>
      </div>
      <div class="form-group my-5" *ngIf="recaptcha">
        <re-captcha (resolved)="resolved($event)" siteKey="{{siteKey}}"></re-captcha>
      </div>
      <!--begin::Action-->
      <div class="w-470 my-5">
        <kt-button-v1
          variant="flat"
          class="auth-btn w-100"
          [fullWidth]="true"
          (btnClick)="submit()"
          [label]="'AUTH.GENERAL.SUBMIT_BUTTON' | translate"
          [disabled]="(isCaptchaSelected && recaptcha) || loading"
          [style.--auth-bg]="((isCaptchaSelected && recaptcha) || loading) ? '#8B8B8D' : '#6340D5'"
          [loading]="loading">
        </kt-button-v1>
      </div>
      <!--end::Action-->
      <div class="signup-head my-5 w-470 pb-5"><a routerLink="/web/forgot-password" class="back-link"
          id="kt_login_signup_cancel">{{ 'AUTH.GENERAL.BACK_BUTTON' | translate }}</a></div>
    </form>
  </div>
</div>